import React, { useEffect, useState } from "react";
import HorziBarChartsMain from "./HorizontalStackBarChart";
import CustomPieChart from "../components/CustomPieChart";
import BarChartsMain from "./BarChartsMain";
import {
  ageRangeWiseCountApi,
  emiWiseCountApi,
  genderWiseCountApi,
  salaryRangeWiseCountApi,
  stateWiseCountApi,
} from "../../../maketingComponents/actioncreator";
import moment from "moment";
import Loader from "../../../../../presentationals/Loader/Loader.component";

function LeadDemographicProfile({ appliedDate }) {
  const [isLoading, setIsLoading] = useState(false);
  const [stateWiseData, setStateWiseData] = useState([]);
  const [genderWiseData, setGenderWiseData] = useState([]);
  const [ageWiseData, setAgeWiseData] = useState([]);
  const [salaryWiseData, setSalaryWiseData] = useState([]);
  const [emiWiseData, setEmiWiseData] = useState([]);
  const getStateWiseData = () => {
    const payload = {
      fromDate: appliedDate?.from
        ? moment(appliedDate.from).format("DD-MM-YYYY")
        : "",
      toDate: appliedDate?.to
        ? moment(appliedDate.to).format("DD-MM-YYYY")
        : "",
    };
    setIsLoading(true);
    stateWiseCountApi(
      payload,"",
      (res) => {
        setIsLoading(false);
        setStateWiseData(res);
      },
      (err) => {
        setIsLoading(false);
        console.log("State wise data error", err);
      },
    );
  };

  const getGenderWiseData = () => {
    const payload = {
      fromDate: appliedDate?.from
        ? moment(appliedDate.from).format("DD-MM-YYYY")
        : "",
      toDate: appliedDate?.to
        ? moment(appliedDate.to).format("DD-MM-YYYY")
        : "",
    };
    setIsLoading(true);
    genderWiseCountApi(
      payload,
      (res) => {
        setIsLoading(false);
        const formattedData = res.map((item) => ({
          name: item?.gender,
          value: item?.count,
          color:
            item?.gender === "Male"
              ? "#035865"
              : item.gender === "Female"
                ? "#EB6062"
                : "#6B7280",
        }));

        setGenderWiseData(formattedData);
      },
      (err) => {
        setIsLoading(false);
        console.log("Gender wise Error", err);
      },
    );
  };

  const getAgeWiseData = () => {
    const payload = {
      fromDate: appliedDate?.from
        ? moment(appliedDate.from).format("DD-MM-YYYY")
        : "",
      toDate: appliedDate?.to
        ? moment(appliedDate.to).format("DD-MM-YYYY")
        : "",
    };
    setIsLoading(true);
    ageRangeWiseCountApi(
      payload,
      (res) => {
        setIsLoading(false);
        setAgeWiseData(res);
      },
      (err) => {
        setIsLoading(false);
        console.log("Gender wise Error", err);
      },
    );
  };

  const getSalaryWiseData = () => {
    const payload = {
      fromDate: appliedDate?.from
        ? moment(appliedDate.from).format("DD-MM-YYYY")
        : "",
      toDate: appliedDate?.to
        ? moment(appliedDate.to).format("DD-MM-YYYY")
        : "",
    };
    setIsLoading(true);
    salaryRangeWiseCountApi(
      payload,
      (res) => {
        setIsLoading(false);
        console.log("fvjjfkr", res);
        setSalaryWiseData(res);
      },
      (err) => {
        setIsLoading(false);
        console.log("Gender wise Error", err);
      },
    );
  };

  const getEmiWiseData = () => {
    const payload = {
      fromDate: appliedDate?.from
        ? moment(appliedDate.from).format("DD-MM-YYYY")
        : "",
      toDate: appliedDate?.to
        ? moment(appliedDate.to).format("DD-MM-YYYY")
        : "",
    };
    setIsLoading(true);
    emiWiseCountApi(
      payload,
      (res) => {
        setIsLoading(false);
        setEmiWiseData(res);
      },
      (err) => {
        setIsLoading(false);
        console.log("Gender wise Error", err);
      },
    );
  };

  useEffect(() => {
    getStateWiseData();
    getGenderWiseData();
    getAgeWiseData();
    getSalaryWiseData();
    getEmiWiseData();
  }, [appliedDate]);

  return (
    <div>
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <div
            style={{
              display: "flex",
              gap: "20px",
              marginTop: "25px",
              flexWrap: "wrap",
            }}
          >
            <div style={{ flex: "2" }}>
              <div
                style={{
                  background: "#fff",
                  border: "1px solid #00000026",
                  borderRadius: "10px",
                  padding: "20px",
                  height: "100%",
                }}
              >
                <HorziBarChartsMain
                  heading={"Daily Trend"}
                  xAxisDataKey={"state"}
                  barData={stateWiseData}
                  dataKeyName1={"total"}
                  dataKeyName2={"count"}
                  barcolor1={"#4FA7C7"}
                  barcolor2={"#4FA564"}
                  LegendLeft={"Total Leads"}
                  LegendRight={"Conversion"}
                  style={{
                    fontSize: "16px",
                    fontWeight: 600,
                    marginTop: "0px",
                    marginBottom: "14px",
                  }}
                />
              </div>
            </div>

            <div style={{ flex: "1" }}>
              <div
                style={{
                  background: "#fff",
                  border: "1px solid #00000026",
                  borderRadius: "10px",
                  padding: "20px",
                  height: "100%",
                }}
              >
                <CustomPieChart
                  title="Gender Distribution"
                  data={genderWiseData}
                />
              </div>
            </div>
          </div>

          <div
            style={{
              display: "flex",
              gap: "20px",
              marginTop: "50px",
              flexWrap: "wrap",
            }}
          >
            <div
              style={{
                flex: "1 1 30%",
                background: "#fff",
                border: "1px solid #00000026",
                borderRadius: "10px",
                padding: "20px",
              }}
            >
              <BarChartsMain
                barcolor={"#EBB569"}
                xAxisDataKey={"emiType"}
                barData={ageWiseData}
                yAxisLabel={"count"}
                heading={"Age Distribution"}
                className={"common-heading"}
              />
            </div>

            <div
              style={{
                flex: "1 1 30%",
                background: "#fff",
                border: "1px solid #00000026",
                borderRadius: "10px",
                padding: "20px",
              }}
            >
              <BarChartsMain
                barcolor={"#7184FFBA"}
                xAxisDataKey={"range"}
                barData={salaryWiseData}
                yAxisLabel={"count"}
                heading={"Salary Range"}
                className={"common-heading"}
              />
            </div>

            <div
              style={{
                flex: "1 1 30%",
                background: "#fff",
                border: "1px solid #00000026",
                borderRadius: "10px",
                padding: "20px",
              }}
            >
              <BarChartsMain
                barcolor={"#FF98C5B0"}
                xAxisDataKey={"emiType"}
                barData={emiWiseData}
                yAxisLabel={"count"}
                heading={"EMI Duration Distribution"}
                className={"common-heading"}
              />
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default LeadDemographicProfile;
